import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { on } from '@ember/modifier';
import { t } from 'ember-intl';
import Icon from './icon.gjs';
import { faCopy } from '../icons/solid.js';

export default class PasswordComponent extends Component {
  @service intl;
  @service notify;

  @action async copyToClipboard() {
    try {
      await navigator.clipboard.writeText(this.args.value);
      this.notify.alert(this.intl.t('password.copy-to-clipboard-success'));
    } catch (error) {
      this.notify.alert(this.intl.t('password.copy-to-clipboard-error'), error);
    }
  }

  <template>
    <span class="flex items-center">
      {{#if @value}}
        <code>{{@value}}</code>
        <button
          type="button"
          title={{t "password.copy-to-clipboard"}}
          class="btn btn-ghost btn-square btn-sm text-primary show-on-hover ml-2"
          {{on "click" this.copyToClipboard}}
        >
          <Icon @icon={{faCopy}} />
        </button>
      {{else}}
        <span>{{t "password.hidden"}}</span>
      {{/if}}
    </span>
  </template>
}
